import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCall, getById, postCall } from "../../utils/api";

const initialState = {
  data: [],
  outletDetail: null,
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getCrawlOutlet = createAsyncThunk(
  "CrawlOutlet/get",
  async ({ from_id = 1, page = 1 }) => {
    try {
      const response = await getCall(
        `/admin/v1/all_outlet_ref?from=${from_id}&page=${page}`,
        false
      );
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const transferCrawlOutlet = createAsyncThunk(
  "CrawlOutlet/transfer",
  async (outlet_ids) => {
    try {
      const response = await postCall(`/admin/v1/transfer_outlet_ref`, {
        outlet_ids,
      });
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getCrawlOutletById = createAsyncThunk(
  "CrawlOutlet/getById",
  async (id) => {
    try {
      const response = await getById("/admin/v1/show_outlet_ref", id, false);
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const assignCrawlOutlet = createAsyncThunk(
  "CrawlOutlet/assign",
  async ({ outlet_ref_id, outlet_id }) => {
    try {
      const res = await postCall(`/admin/v1/outlet_ref/assign`, {
        outlet_ref_id,
        outlet_id,
      });
      return res;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const acceptSuggestion = createAsyncThunk(
  "CrawlOutlet/acceptSuggestion",
  async ({ outlet_ref_id, suggestions }) => {
    try {
      const res = await postCall(`/api/v1/outlet-matching/outlet-refs/${outlet_ref_id}/accept-suggestion`, {
        suggestions,
      });
      return { outlet_ref_id, ...res };
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

const CrawlOutletSlice = createSlice({
  name: "crawlOutlet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCrawlOutlet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCrawlOutlet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getCrawlOutlet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getCrawlOutletById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCrawlOutletById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getCrawlOutletById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.outletDetail = action.payload;
      })
      .addCase(transferCrawlOutlet.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(transferCrawlOutlet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.data.push(action.payload);
      })
      .addCase(transferCrawlOutlet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(assignCrawlOutlet.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(assignCrawlOutlet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.data.push(action.payload);
      })
      .addCase(assignCrawlOutlet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(acceptSuggestion.pending, (state) => {
        state.isUpdateStatus = "loading";
      })
      .addCase(acceptSuggestion.fulfilled, (state, action) => {
        state.isUpdateStatus = "succeeded";
        const index = state.data?.data?.findIndex(
          (item) => item.id === action.payload.outlet_ref_id
        );
        if (index !== -1 && state.data?.data) {
          state.data.data[index].match_status = "matched";
          state.data.data[index].google_place_id = action.payload.data?.google_place_id;
        }
      })
      .addCase(acceptSuggestion.rejected, (state, action) => {
        state.isUpdateStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      });
  },
});

export default CrawlOutletSlice.reducer;
